{
  "carrierLabel": "Транспортна компанія",
  "searchPlaceholder": "Пошук за назвою",
  "selectAsCarrier": "Вибрати \"{name}\" як перевізника",
  "typeToSearch": "Введіть для пошуку компанії"
}
